import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Renderer } from "@unseenco/taxi";

gsap.registerPlugin(ScrollTrigger);

import GlobalHandler from "../global/global";
import AnimationHandler from "../global/animations";
import ScrollHandler, { lenis } from "../global/scroll";
import VideoHandler from "../global/video";
import GradientTextHandler from "../global/gradient";
import CarouselHandler from "../partials/carousel";
import HeaderHandler from "../partials/header";
import AccordionHandler from "../partials/accordion";
import FiltersHandler from "../partials/filters";
import Modal from "../partials/modal";
import FormsHandler from "../partials/forms";
import LocationGridHandler from "../partials/location-grid";
import CardsHandler from "../partials/cards";
import FooterHandler from "../partials/footer";

const global = new GlobalHandler();
const animation = new AnimationHandler();
const scroll = new ScrollHandler();
const video = new VideoHandler();
const gradient = new GradientTextHandler();
const carousel = new CarouselHandler();
const header = new HeaderHandler();
const accordion = new AccordionHandler();
const modal = new Modal();
const forms = new FormsHandler();
const locationGrid = new LocationGridHandler();
const cards = new CardsHandler();
const footer = new FooterHandler();
let filters = null;

export default class RendererDefault extends Renderer {
    initialLoad() {
        this.onEnter(
            global.viewHeight(),
            scroll.init(),
        );
        this.onEnterCompleted(
            header.init(),
        );
    }
    onEnter() {
        lenis.scrollTo(0, { immediate: true });

        animation.animations();
        gradient.init();
        carousel.init();
        accordion.init({
            oneAtATime: true
        });
        filters = new FiltersHandler();
        filters.init();
        forms.init();
        modal.init();
        video.customPlayer();
        header.initHeaderTheme();
    }
    onEnterCompleted() {
        header.scroll();
        header.updateActiveLinks();
        locationGrid.init();
        cards.init();
        footer.init();
    }
    onLeave() {
    }
    onLeaveCompleted() {
        let triggers = ScrollTrigger.getAll();
        triggers.forEach((trigger) => {
            trigger.kill();
        });
        header.reset();
        forms.destroy();
    }
}